(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('trworkorder-type', {
            parent: 'entity',
            url: '/trworkorder-type',
            data: {
                authorities: ['ENTITY_CONFIGURATION'],
                pageTitle: 'trakeyeApp.trWorkOrderType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/trworkorder-type/trworkorder-types.html',
                    controller: 'TrWorkOrderTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'update_date,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('trWorkOrderType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('trworkorder-type-detail', {
            parent: 'trworkorder-type',
            url: '/trworkorder-type/{id}',
            data: {
                authorities: ['ENTITY_CONFIGURATION'],
                pageTitle: 'trakeyeApp.trWorkOrderType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/trworkorder-type/trworkorder-type-detail.html',
                    controller: 'TrWorkOrderTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('trWorkOrderType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TrWorkOrderType', function($stateParams, TrWorkOrderType) {
                    return TrWorkOrderType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'trworkorder-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
        .state('trworkorder-type.new', {
            parent: 'trworkorder-type',
            url: '/create',
            data: {
                authorities: ['ENTITY_CONFIGURATION']
            },
			views:{
				'content@':{
					templateUrl: 'app/entities/trworkorder-type/trworkorder-type-dialog.html',
                    controller: 'TrWorkOrderTypeDialogController',
                    controllerAs: 'vm'
				}
			},
			resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                createdDate: null,
                                updateDate: null,
                                id: null
                            };
                        }
                    }
        })
		.state('trworkorder-type.edit', {
            parent: 'trworkorder-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ENTITY_CONFIGURATION'],
                pageTitle: 'trakeyeApp.trWorkOrderType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/trworkorder-type/trworkorder-type-dialog.html',
                    controller: 'TrWorkOrderTypeDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('trWorkOrderType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TrWorkOrderType', function($stateParams, TrWorkOrderType) {
                    return TrWorkOrderType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'trworkorder-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
      
        .state('trworkorder-type.delete', {
            parent: 'trworkorder-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ENTITY_CONFIGURATION']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/trworkorder-type/trworkorder-type-delete-dialog.html',
                    controller: 'TrWorkOrderTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                        entity: ['TrWorkOrderType', function(TrWorkOrderType) {
                            return TrWorkOrderType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('trworkorder-type', null, { reload: 'trworkorder-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
